import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { CashPaymentModel } from '../model/index';
//import { debugger } from 'fusioncharts';

@Injectable()
export class CashPaymentService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private cashPaymentUrl = 'api/cashPayment';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

   
    getCashPaymentList(query: any): Promise<CashPaymentModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cashPaymentUrl}/getCashPaymentList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteCashPayment(cashPayment: any): Promise<CashPaymentModel> {

        const url = `${this.cashPaymentUrl}/deleteCashPayment`;

        return this.http
            .post(url, $.param(cashPayment), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CashPaymentModel)
            .catch(this.handleError);
    }
    addCashPaymentDetails(stkData: any): Promise<CashPaymentModel> {

        const url = `${this.cashPaymentUrl}/addCashPaymentDetails`;

        return this.http
            .post(url, $.param(stkData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CashPaymentModel)
            .catch(this.handleError);
    }

    getClientByNo(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        let options = new RequestOptions({ headers: this.headers, search: params });
        const url = `${this.cashPaymentUrl}/getClientByNo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getBillsByClientDate(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        let options = new RequestOptions({ headers: this.headers, search: params });
        const url = `${this.cashPaymentUrl}/getBillsByClientDate`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/cashPayment.service.ts